import styled, { css } from "styled-components";
import buildColor from "../../_static/ColorPalette";
import { fontNormal } from "../../_static/Typography";
import ButtonLink from "../../_atom/Buttons/buttonLink";
import { whiteGhost, whiteGhostActive } from "../../_static/Colors";

export const HeaderContainer = styled.header`
  display: flex;
  flex-shrink: 0;
  justify-content: space-between;
  padding: 0 12px;
  z-index: 1;

  @media only screen and (max-width: 767px) {
    background-color: ${buildColor("blue", "900")};
    align-items: center;
    height: ${({ isWelcomePage }) => (isWelcomePage ? "46px" : "70px")};
    height: ${({ isEditing }) => isEditing && "46px"};
    position: fixed;
    width: 100%;
    top: 0;
    left: 0;
  }

  @media only screen and (min-width: 768px) {
    padding-top: ${({ isEditing }) => (isEditing ? "0" : "25px")};
    justify-content: center;
    background-color: transparent;
  }
`;

export const SpacingSpan = styled.span`
  flex: 1;
  visibility: hidden;
`;

export const DesktopLogoWrapper = styled.div`
  position: relative;
  flex: 2;
  display: flex;
  justify-content: center;
`;

export const LogoButton = styled(ButtonLink)`
  background-color: transparent !important;
  cursor: pointer;

  &:hover {
    background-color: transparent !important;
  }

  svg {
    height: 18px;
  }

  @media only screen and (min-width: 768px) {
    svg {
      height: 25px;
    }
  }
`;

export const RedirectButtonWrapper = styled.div`
  position: relative;
  flex: 1;
  display: flex;
  justify-content: flex-end;

  @media only screen and (min-width: 768px) {
    justify-content: center;
  }
`;

export const RedirectButton = styled(ButtonLink)`
  font-family: ${fontNormal};
  font-weight: 500;
  font-size: 14px;
  color: ${buildColor("white", "100")};
  background-color: transparent !important;
  cursor: pointer;
  padding: 0;
  width: 36px;

  &:hover {
    background-color: transparent;
  }

  @media only screen and (min-width: 768px) {
    position: absolute;
    top: 0;
    left: 120px;
    height: 24px;
  }
`;

export const ButtonWrapper = styled.button`
  ${({ isMobile }) =>
    isMobile
      ? css`
          background-color: transparent;
          margin-bottom: ${({ isEditing }) => (isEditing ? "0" : "14px")};
        `
      : css`
          position: absolute;
          top: 0;
          left: 0;
          height: 44px;
          width: 44px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
          background-color: ${whiteGhostActive.value};
          &:hover {
            background-color: ${whiteGhost.value};
          }
        `}

  outline: none;
  ${({ isFullSsn }) =>
    isFullSsn &&
    css`
      visibility: hidden;
    `}
`;

export const MiddleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 480px;
  z-index: 2;
`;

export const InnerTitleWrapper = styled.div`
  width: 100%;
  height: 44px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  @media only screen and (min-width: 768px) {
    margin: 14px 0 20px;
  }
`;

export const MidHeaderWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-right: ${({ isWelcomeHeaderCollapsed }) =>
    isWelcomeHeaderCollapsed ? "0" : "16px"};

  @media only screen and (min-width: 768px) {
    padding-right: 0;
  }
`;
